import {
  makeStyles,
  mergeClasses,
  shorthands,
  useToggleButtonStyles_unstable,
  createCustomFocusIndicatorStyle,
} from "@fluentui/react-components";

// eslint-disable-next-line no-restricted-imports
import {
  commonHighContrastBackgroundHoverFocus,
  commonHighContrastColorDisabled,
  commonHighContrastColorHoverFocus,
  commonHighContrastOutlineToggledOn,
  HighContrastSelector,
} from "@1js/acui-common/lib/styling/next/commonStyles.styles";
import { customTokens, isNextStyleEnabled } from "@1js/acui-theme";

import { useRibbonButtonCustomStyles } from "../../RibbonButton/next/useRibbonButtonStyles.styles";
import type { RibbonToggleButtonState } from "./RibbonToggleButton.types";

export const useRibbonToggleButtonRootStyles = makeStyles({
  checked: {
    backgroundColor: customTokens.legacy_neutralLight,
    color: customTokens.legacy_neutralDark,
    ...shorthands.borderColor(customTokens.legacy_neutralPrimaryAlt),

    [`${HighContrastSelector}`]: {
      ...commonHighContrastBackgroundHoverFocus,
      ...commonHighContrastColorHoverFocus,
      ...commonHighContrastOutlineToggledOn,
    },
  },
  disabled: {
    [`${HighContrastSelector}`]: {
      ...commonHighContrastColorDisabled,
      ":focus": {
        ...commonHighContrastColorDisabled,
      },
    },
  },
});

export const useRibbonToggleButtonRootStylesNext = makeStyles({
  checked: {
    ...shorthands.borderColor(customTokens.colorNeutralStrokeAccessible),
    ...createCustomFocusIndicatorStyle({
      "@media (forced-colors: active)": {
        ...shorthands.borderColor("ButtonText"),
        outlineColor: "ButtonText",
      },
    }),
  },
});

export const useRibbonToggleButtonStyles = (
  state: RibbonToggleButtonState
): RibbonToggleButtonState => {
  const styles = useRibbonToggleButtonRootStyles();
  const stylesNext = useRibbonToggleButtonRootStylesNext();

  if (!isNextStyleEnabled()) {
    state.root.className = mergeClasses(
      state.checked && styles.checked,
      (state.disabled || state.disabledFocusable) && styles.disabled,
      state.root.className
    );
  } else {
    state.root.className = mergeClasses(
      state.checked && stylesNext.checked,
      state.root.className
    );
  }

  useRibbonButtonCustomStyles(state);

  useToggleButtonStyles_unstable(state);

  return state;
};
